// Reviews loader — fetches approved reviews from app API
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const container = document.getElementById('reviews-container');
    if (!container) return;
    const productId = container.dataset.productId;
    if (!productId) return;

    fetch('/apps/birdie-shots/api/reviews?product_id=' + productId)
      .then(r => r.json())
      .then(data => {
        if (data && data.reviews) {
          container.dispatchEvent(new CustomEvent('reviews:loaded', { detail: data }));
        }
      })
      .catch(() => {});
  });
})();
